module.exports = __webpack_public_path__ + "img/6.afc91fd2.png";